import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductTour } from '../../models/product-tour';
import { ProductTourService } from '../../services/product-tour.service';

/** "Show guide" button that (re)starts the given product tour on demand. */
@Component({
    selector: 'apcam-product-tour-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatIconModule, TranslatePipe],
    templateUrl: './product-tour-button.component.html',
    styleUrl: './product-tour-button.component.scss',
})
export class ProductTourButtonComponent {
    readonly tour = input.required<ProductTour>();

    private readonly productTourService = inject(ProductTourService);

    protected startTour(): void {
        this.productTourService.start(this.tour());
    }
}
